(function() { window.GUID_b9bc3b4e_d369_46c2_a2ab_3afd1483e33f = { getGuid: function() { return "b9bc3b4e-d369-46c2-a2ab-3afd1483e33f"; } }; })();
var Menu;
(function (Menu) {
    var desktop;
    (function (desktop) {
        var isShowingHidingMenu = false;
        Menu.csMainMenuButton.on('mouseenter', function (e) {
            Menu.csMainMenuButton.off('mouseleave');
            Menu.csMainMenuButton.on('mouseleave', function (e) {
                if (!isShowingHidingMenu) {
                    //Ne fonctionne pas si on réutilise csMainMenuIcon pour hasClass
                    var left = $('#CSMainMenuButton').hasClass('IsOpened') ? '10px' : '0';
                    Menu.csMainMenuIcon.animate({ 'left': left }, 250);
                }
            });
            Menu.csMainMenuIcon.animate({ 'left': '5px' }, 250);
        });
        function ShowHideMenu(show) {
            isShowingHidingMenu = true;
            if (show || (Menu.mainMenu.is(':visible') && show == false)) {
                //CallKeepMenuState("MainMenu", show ? 'IsOpened' : 'IsClosed');
                if (show) {
                    Menu.csMainMenuIcon.animate({ 'left': '10px' }, 250);
                    Menu.mainMenu.show("slide", { direction: "left" }, 250, function () {
                        Menu.csMainMenuButton.addClass('IsOpened');
                        isShowingHidingMenu = false;
                    });
                    CS.trigger("menuShow");
                }
                else {
                    Menu.csMainMenuIcon.animate({ 'left': '0' }, 250);
                    Menu.toolBarContainer.show();
                    Menu.mainMenu.hide("slide", { direction: "left" }, 250, function () {
                        Menu.csMainMenuButton.removeClass('IsOpened');
                        isShowingHidingMenu = false;
                    });
                }
            }
        }
        desktop.ShowHideMenu = ShowHideMenu;
    })(desktop = Menu.desktop || (Menu.desktop = {}));
})(Menu || (Menu = {}));

//# sourceMappingURL=Menu.desktop.js.map
